module.exports = __webpack_public_path__ + "static/media/calendar_icon.cff82d64.svg";